import { User } from 'toolbandi-ui-lib';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { of } from 'rxjs/internal/observable/of';
import { Observable } from 'rxjs/Observable';
import { SharedDataService, AuthService, AclService } from 'elbuild-ui-lib-core';
import { catchError, map, switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';



@Injectable()
export class AuthenticationGuardService implements CanActivate, CanActivateChild {

	loggedUser: User;

	constructor(private sharedDataService: SharedDataService,
		private router: Router,
		private authService: AuthService,
		private aclService: AclService) {
		this.sharedDataService.currentLoggedUser.subscribe(loggedUser => { this.loggedUser = loggedUser as User; });
	}


	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		if (this.loggedUser) {
			return this.checkAclFeatures(route);
		} else {
			if (this.authService.hasCookie()) {
				return this.authService.getLoggedUser().pipe(switchMap((user: any) => {
					return this.checkAclFeatures(route);
				}))
			} else {
				const loginpage = 'signin';
				this.router.navigate([loginpage], {});
				return of(false);
			}
		}
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.checkAclFeatures(route);
	}

	checkAclFeatures(route: ActivatedRouteSnapshot): Observable<boolean> {

		if (!this.loggedUser) {
			return of(false);
		}

		const types = route.data.types;
		return this.hasPermission(types, this.loggedUser.utype, route.data.aclFeatures, route.data.section).pipe(map(data => {
			return data;
		}), catchError((error: any) => {
			console.log(error);
			return of(false);
		}));
	}


	hasPermission(types: string[], type: string, routeFeatures: string[], routeSection: string): Observable<boolean> {
		let typeperm: boolean;

		if (!type) {
			typeperm = false;
		} else
			if (!types || !types.length) {
				typeperm = true;
			} else {
				typeperm = types.indexOf(type) >= 0;
			}



		if (!typeperm) {
			return of(false);
		}
		else {
			const aclFeatures = routeFeatures;
			if (!aclFeatures || !aclFeatures.length) {
				return of(true);
			}
			else {
				return combineLatest([this.aclService.hasPermission(aclFeatures),
				this.aclService.hasPermissionInSection(routeSection)]).pipe(map(data => {
					const perm = data[0] && data[1];
					if (perm) {
						return true;
					} else {
						this.router.navigateByUrl('/unauthorized');

					}
				}), catchError((error: any) => {
					console.log('error');
					console.log(error);
					return of(false);
				}));
			}
		}

	}

}
